import { render, staticRenderFns } from "./GoodsText.vue?vue&type=template&id=1857669e&scoped=true&"
import script from "./GoodsText.vue?vue&type=script&lang=js&"
export * from "./GoodsText.vue?vue&type=script&lang=js&"
import style0 from "./GoodsText.vue?vue&type=style&index=0&id=1857669e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857669e",
  null
  
)

export default component.exports